export default "__VITE_ASSET__DXVWc__i__"